// extracted by css-extract-rspack-plugin
export default {"tableWrapper":"pu6Zej2HKOk6oCe2"};